import { FC } from 'react'
import Map from './Map';
import { ContactStation } from '../../../../hooks/useGroundContact';
import CustomToolTip from '../../../../../CommonComponents/CustomToolTip';
import ToggleMapButton from './ToggleMapButton';
import { MaximizeSvg } from '../Svgs';
import { get_contact_pass_details } from '../utils';
interface Props {
    set_show_modal: () => void;
    all_contacts: {
        previous_contacts: null | ContactStation[],
        ongoing_contacts: null | ContactStation[],
        upcoming_contacts: null | ContactStation[]
        current_time: null | number,
    };
    selected_contact: {
        contact_type: string;
        contact_data: ContactStation,
    } | any | null
}
const RightSidePanel: FC<Props> = ({ set_show_modal, all_contacts, selected_contact }) => {
    const { previous_contacts, ongoing_contacts, upcoming_contacts, current_time } = all_contacts

    return (
        <div className='ground__container__right__container'>
            <div className='d-flex flex-column gap-2'>
                <div className='contact__details__header'>
                    <span className='contact__details__header__title'>
                        <CustomToolTip title={`${selected_contact?.contact_data?.antennaId ? selected_contact?.contact_data?.antennaId : selected_contact?.contact_data?.groundStationName}, ${selected_contact?.contact_data?.groundStationProperties?.country}`} placement='bottom'>
                            {selected_contact?.contact_data?.antennaId ? selected_contact?.contact_data?.antennaId : selected_contact?.contact_data?.groundStationName ? `${selected_contact?.contact_data?.groundStationName}, ${selected_contact?.contact_data?.groundStationProperties?.country}` : '--'}
                        </CustomToolTip>
                    </span>
                    <span className='contact__details__header__sub__title'>
                        <CustomToolTip title={`${selected_contact?.contact_data?.groundStationProviderName}`} placement='bottom'>
                            {selected_contact?.contact_data?.groundStationProviderName}
                        </CustomToolTip>
                    </span>
                </div>
                <div className={`contact__status__badge ${selected_contact?.contact_type === 'Ongoing' && 'ongoing'}`}>
                    <span className='badge__title'>{selected_contact?.contact_type}</span>
                    <div className='time__container'>{current_time && get_contact_pass_details(selected_contact?.contact_type, selected_contact?.contact_data, current_time).remaining}</div>
                </div>
            </div>
            <div className='contact__visualization__miniview'>
                <Map selected_contact={selected_contact} />
                <ToggleMapButton className='small' onClick={set_show_modal}>
                    <MaximizeSvg />
                </ToggleMapButton>
            </div>
            <div className='ground__contact__details'>
                <span>Contact ID</span>
                <span>
                    {selected_contact?.contact_data?.['contactGspId'] || '--'}
                </span>
            </div>
            <div className='ground__contact__details'>
                <span>Contact Time</span>
                <span>{current_time && get_contact_pass_details(selected_contact?.contact_type, selected_contact?.contact_data, current_time).time}</span>
            </div>
            <div className='ground__contact__details'>
                <span>Duration</span>
                <span>{current_time && get_contact_pass_details(selected_contact?.contact_type, selected_contact?.contact_data, current_time).duration}</span>
            </div>
            <div className='ground__contact__details'>
                <span>Communication Bands</span>
                <div className="band">
                    <span className="band">{selected_contact?.contact_data?.['bandInfo']?.['bandName']}</span>
                </div>
            </div>
            <div className='ground__contact__details__separator' />
            <div className='ground__contact__task__details__container'>
                <span>Contacts</span>
                {upcoming_contacts &&
                    <div className={`ground__contact__event__card upcomming`}>
                        <div className='card__left__section'>
                            <span>Upcoming Contact</span>
                        </div>
                        <div className='card__right__section'>
                            <span>{upcoming_contacts?.[0]?.['antennaId'] ? upcoming_contacts?.[0]?.['antennaId'] : upcoming_contacts?.[0]?.['groundStationName']}</span>
                            <span className='time_format'>
                                <CustomToolTip title={current_time ? get_contact_pass_details('Upcoming', upcoming_contacts?.[0], current_time)?.time : ''} placement='top'>
                                    {current_time && get_contact_pass_details('Upcoming', upcoming_contacts?.[0], current_time)?.time}
                                </CustomToolTip>
                            </span>
                        </div>
                    </div>
                }
                {ongoing_contacts &&
                    <div className={`ground__contact__event__card ongoing`}>
                        <div className='card__left__section'>
                            <span>Active Contact</span>
                        </div>
                        <div className='card__right__section'>
                            <span>{ongoing_contacts?.[0]?.['antennaId'] ? ongoing_contacts?.[0]?.['antennaId'] : ongoing_contacts?.[0]?.['groundStationName']}</span>
                            <span className='time_format'>
                                <CustomToolTip title={`${current_time && get_contact_pass_details('Ongoing', ongoing_contacts?.[0], current_time)?.time}`} placement='top'>
                                    {current_time && get_contact_pass_details('Ongoing', ongoing_contacts?.[0], current_time)?.time}
                                </CustomToolTip>
                            </span>
                        </div>
                    </div>
                }
                {previous_contacts &&
                    <div className={`ground__contact__event__card completed`}>
                        <div className='card__left__section'>
                            <span>Previous Contact</span>
                            <div className='contact__status__badge'>Completed</div>
                        </div>
                        <div className='card__right__section'>
                            <span>{previous_contacts?.[0]?.['antennaId'] ? previous_contacts?.[0]?.['antennaId'] : previous_contacts?.[0]?.['groundStationName']}</span>
                            <span className='time_format'>
                                <CustomToolTip title={current_time ? get_contact_pass_details('Previous', previous_contacts?.[0], current_time)?.time : ''} placement='top'>
                                    {current_time && get_contact_pass_details('Previous', previous_contacts?.[0], current_time)?.time}
                                </CustomToolTip>
                            </span>
                        </div>
                    </div>
                }
            </div>
        </div>
    )
}

export default RightSidePanel